/* Russian copy for the admin web. Kept inline (not JSON) so TypeScript
   catches missing keys at compile time via the `Resources` type below. */

export const ru = {
  common: {
    app_name: 'Twin Turbo Admin',
    sign_out: 'Выйти',
    account: 'Аккаунт',
    loading: 'Загрузка…',
    error_generic: 'Что-то пошло не так. Попробуйте ещё раз.',
    create: 'Создать',
    edit: 'Изменить',
    delete: 'Удалить',
    save: 'Сохранить',
    cancel: 'Отмена',
    confirm: 'Подтвердить',
    confirm_delete: 'Удалить',
    actions: 'Действия',
    empty: 'Пусто.',
    copy: 'Копировать',
    copied: 'Скопировано',
    close: 'Закрыть',
    no_access_title: 'Нет доступа',
    no_access_body: 'У вашей роли нет прав на этот раздел. Обратитесь к администратору.',
  },
  notifications: {
    enable: 'Включить уведомления',
    disable: 'Выключить уведомления',
    blocked: 'Уведомления заблокированы в браузере',
  },
  pwa: {
    install: 'Установить приложение',
  },
  pwa_update: {
    available: 'Доступно обновление',
    later: 'Позже',
    reload: 'Обновить',
  },
  auth: {
    login_title: 'Вход',
    login_subtitle: 'Диспетчеры и кабинеты клиентов',
    username: 'Логин',
    password: 'Пароль',
    otp_label: 'Код 2FA',
    otp_hint: 'Шестизначный код из приложения-аутентификатора',
    remember_me: 'Запомнить меня',
    submit: 'Войти',
    submit_with_otp: 'Подтвердить',
    error_invalid_credentials: 'Неверный логин или пароль.',
    error_rate_limited: 'Слишком много попыток. Подождите 15 минут.',
    error_account_locked: 'Аккаунт заблокирован. Обратитесь к администратору.',
    error_otp_required: 'Введите код двухфакторной аутентификации.',
    error_otp_invalid: 'Неверный код 2FA.',
    error_network: 'Нет связи с сервером.',
    or: 'или',
    session_expired: 'Сессия истекла. Войдите снова.',
  },
  webauthn: {
    login_button: 'Войти по Face ID',
    register_prompt_title: 'Включить вход по Face ID?',
    register_prompt_body:
      'В следующий раз можно будет войти по биометрии этого устройства — без пароля и кода 2FA.',
    register_confirm: 'Включить',
    register_dismiss: 'Не сейчас',
    register_error: 'Не удалось зарегистрировать Face ID. Попробуйте ещё раз.',
    manage_title: 'Face ID / Touch ID',
    credentials_empty: 'Face ID не подключён на других устройствах.',
    credential_created: 'Добавлено',
    credential_last_used: 'Последний вход',
    credential_never_used: 'ещё не использован',
    delete: 'Удалить',
    delete_error: 'Не удалось удалить.',
  },
  nav: {
    dashboard: 'Главная',
    orders: 'Заказы',
    map: 'Карта',
    operators: 'Водители',
    providers: 'Провайдеры',
    clients: 'Клиенты',
    catalog: 'Справочники',
    consumers: 'Клиенты B2C',
    consumer_zones: 'Города B2C',
    pricing: 'Цены',
    personal_car_settings: 'Отмена и no-show',
    refill_requests: 'Дозаправки',
    chat: 'Чат',
    reports: 'Отчёты',
    report_builder: 'Конструктор',
    admins: 'Пользователи',
    admin_roles: 'Роли и права',
  },
  layout: {
    sidebar_label: 'Главная навигация',
    section_main: 'Основное',
    section_admin: 'Администрирование',
    section_other: 'Прочее',
    collapse_sidebar: 'Свернуть меню',
    expand_sidebar: 'Развернуть меню',
    open_menu: 'Открыть меню',
    menu: 'Меню',
  },
  dashboard: {
    placeholder: 'Список заказов — в разделе «Заказы», карта водителей — в разделе «Карта».',
    subtitle: 'Оперативная сводка по смене',
    kpi_active: 'Активные заказы',
    kpi_problem: 'Проблемные',
    kpi_online: 'Водители онлайн',
    kpi_providers: 'Провайдеры',
    kpi_total: 'всего',
    kpi_of: 'из',
    recent_orders: 'Последние заказы',
    by_provider: 'По провайдерам',
    by_fuel_type: 'По видам топлива',
    breakdown_empty: 'Нет данных.',
    donut_total_label: 'активных',
    weekly_completed: 'Выполнено заказов · последние 7 дней',
    weekly_completed_hint: 'Наведи на точку — литры по видам топлива. Клик — заказы этого дня.',
    weekly_completed_count: '{{count}} заказов',
    weekly_completed_cta: 'Заказы за {{date}} →',
    weekly_completed_point_label: '{{date}} — {{count}} заказов, открыть список',
    today: 'сегодня',
    live_feed: 'Живая лента',
    live_feed_empty: 'Пока нет событий — появятся сразу, как только что-то произойдёт.',
    live_feed_generic: 'Заказ обновлён',
    attention_queue: 'Требует внимания',
    attention_queue_empty: 'Ничего не требует внимания.',
    attention_urgent: 'срочно, не назначен',
    elapsed_just_now: 'только что',
    elapsed_minutes: '{{count}} мин',
    elapsed_hours: '{{count}} ч',
    elapsed_days: '{{count}} дн',
    online_roster: 'Сейчас на линии',
    online_roster_empty: 'Никого нет на линии.',
    online_roster_free: 'свободен',
  },
  orders: {
    title: 'Заказы',
    col_ref: 'Заказ',
    col_status_date: 'Дата',
    col_car: 'Госномер',
    col_state: 'Статус',
    col_operator: 'Водитель',
    col_fuel: 'Топливо',
    col_liters: 'Литры',
    col_actions: 'Действия',
    col_consumer: 'Клиент',
    consumer_chip: 'Клиент: {{email}}',
    scheduled_badge: 'Запланирован',
    scheduled_window: 'Окно доставки',
    scheduled_hint: 'Заявка ждёт своего окна — водитель получит её к началу, назначать вручную не нужно.',
    scheduled_assign_confirm:
      'Заявка запланирована на {{window}}. Если назначить водителя сейчас, он поедет немедленно. Всё равно назначить?',
    fiscal_receipts: 'Чеки (54-ФЗ)',
    receipt_fd: 'ФД',
    receipt_fp: 'ФП',
    receipt_pending: 'Ожидает фискализации',
    receipt_failed: 'Чек не пробит',
    receipt_trigger: {
      completion: 'Заправка',
      overflow_payment: 'Доплата',
      paid_cancellation: 'Платная отмена',
      no_show: 'Клиент не вышел',
    },
    completed_on_chip: 'Выполнено {{date}}',
    filter_state: 'Статус:',
    filter_operator: 'Водитель:',
    filter_provider: 'Провайдер:',
    filter_origin: 'Тип:',
    filter_date_from: 'Дата от',
    filter_date_to: 'Дата до',
    search_car_placeholder: 'Поиск по госномеру…',
    filter_all: 'Все',
    origin_integration: 'Интеграция',
    origin_manual: 'Ручные',
    badge_urgent: 'Срочно',
    cars_title: 'Машины в выезде',
    cars_requested: 'просили',
    cars_poured: 'залито',
    cars_added_later: 'добавлена в пути',
    car_status_pending: 'ждёт заправки',
    car_status_refueled: 'заправлена',
    car_status_skipped: 'пропущена',
    car_status_cancelled: 'снята',
    badge_manual: 'Ручной',
    total: 'Всего: {{n}}',
    empty: 'Заказов не найдено.',
    prev: 'Назад',
    next: 'Вперёд',
    assign: 'Назначить',
    assign_select: 'Выбор водителя',
    assign_pick: '— водитель —',
    assign_mode_manual: 'ручной',
    cancel: 'Отменить',
    mark_error: 'Проблемный',
    approval_in_chat: 'В чат',
    show_on_map: 'Показать на карте',
    approve_start: 'Одобрить старт',
    reject_start: 'Отклонить старт',
    approve_completion: 'Одобрить завершение',
    reject_completion: 'Отклонить завершение',
    approve_problematic: 'Это новый заказ',
    reject_problematic: 'Отменить',
    history: 'История статусов',
    fuel_amount: 'Объём',
    total_price: 'Сумма',
    coords: 'Координаты',
    invoice: 'Расчёт',
    invoice_fuel: 'Топливо',
    invoice_total: 'Итого',
    videos: 'Видео заправки',
    videos_empty: 'Видео пока нет.',
    video_watch: 'Смотреть',
    video_download: 'Скачать',
    video_share: 'Копировать ссылку',
    video_share_copied: 'Ссылка скопирована',
    media: 'Видео и фото заправки',
    media_empty: 'Видео и фото пока нет.',
    media_video: 'Видео',
    media_photo: 'Фото',
    photo_open: 'Открыть',
    /* Russian label per OrderState wire value (crates/orders/src/states.rs) — all 38, see
       ALL_ORDER_STATES in entities/order/model.ts for the completeness check. Grouped to match
       the state machine's own lifecycle-stage comments. */
    state: {
      OPEN: 'Открыт',
      ADMIN_REQUESTED_PENDING: 'Предложен водителю',
      ADMIN_REQUESTED_TAKEN: 'Принят по назначению',
      ADMIN_REQUESTED_CANCELED: 'Отменён',

      OPERATOR_IN_WAY: 'В пути',
      OPERATOR_START_PENDING_APPROVAL: 'Ждёт одобрения старта',
      OPERATOR_ARRIVED: 'На месте',

      OPERATOR_UNLOCK_REQUEST: 'Открывается',
      OPERATOR_UNLOCK_APPROVED: 'Машина открыта',
      OPERATOR_UNLOCK_FAILED: 'Не открылась',

      OPERATOR_REFILL_STARTED: 'Идёт заправка',
      OPERATOR_REFILL_FINISHED: 'Заправка завершена',
      OPERATOR_COMPLETION_PENDING_APPROVAL: 'Ждёт одобрения завершения',

      OPERATOR_ORDER_SUBMISSION_STARTED: 'Отправка провайдеру',
      OPERATOR_ORDER_SUBMISSION_FAILED: 'Ошибка отправки',
      OPERATOR_ORDER_SUBMISSION_COMPLETED: 'Отправлено провайдеру',

      OPERATOR_ORDER_CANCELLATION_STARTED: 'Отменяется водителем',
      OPERATOR_ORDER_CANCELLATION_FAILED: 'Ошибка отмены (водитель)',
      OPERATOR_ORDER_CANCELLATION_COMPLETED: 'Отменён водителем',

      PROVIDER_ORDER_CANCELLATION_STARTED: 'Отменяется провайдером',
      PROVIDER_ORDER_CANCELLATION_FAILED: 'Ошибка отмены (провайдер)',
      PROVIDER_ORDER_CANCELLATION_COMPLETED: 'Отменён провайдером',

      NEW_ORDER_RECEIVED_FOR_CAR: 'Заменён новым заказом',

      ADMINISTRATOR_FINISH_STARTED: 'Диспетчер завершает',
      ADMINISTRATOR_EXTERNAL_FINISH_STARTED: 'Диспетчер завершает (провайдер)',
      ADMINISTRATOR_EXTERNAL_FINISH_FAILED: 'Ошибка завершения (провайдер)',
      ADMINISTRATOR_EXTERNAL_FINISH_COMPLETED: 'Завершён диспетчером (провайдер)',
      ADMINISTRATOR_FINISH_COMPLETED: 'Завершён диспетчером',
      ADMINISTRATOR_FINISH_FAILED: 'Ошибка завершения',

      ADMINISTRATOR_UNLOCK_REQUEST: 'Диспетчер открывает',
      ADMINISTRATOR_UNLOCK_APPROVED: 'Диспетчер открыл',
      ADMINISTRATOR_UNLOCK_FAILED: 'Диспетчер не открыл',

      ADMINISTRATOR_LOCK_REQUEST: 'Диспетчер закрывает',
      ADMINISTRATOR_LOCK_APPROVED: 'Диспетчер закрыл',
      ADMINISTRATOR_LOCK_FAILED: 'Диспетчер не закрыл',

      PROBLEMATIC: 'Проблемный',
      EXPIRED: 'Просрочен',
      COMPLETED: 'Завершён',
    },
    // Fallback label for a status-history actor when the name can't be resolved (SYSTEM
    // step, or an actor the current admin can't look up). Vocabulary matches the app-wide
    // «Водитель»/«Диспетчер» rename — never the raw wire words.
    actor: {
      SYSTEM: 'Система',
      OPERATOR: 'Водитель',
      ADMINISTRATOR: 'Диспетчер',
      PROVIDER: 'Провайдер',
    },
  },
  map: {
    active_orders: 'Активных заказов: {{n}}',
    online_operators: 'Водителей на линии: {{n}}',
    unavailable: 'Карта недоступна (нет ключа Yandex JS API или ошибка загрузки).',
    assign_mode_banner: 'Режим назначения — выберите водителя на карте',
    assign_mode_cancel: 'Отмена',
    fullscreen: 'Во весь экран',
    exit_fullscreen: 'Свернуть',
  },
  catalog: {
    title: 'Справочники',
    fuel_types: 'Виды топлива',
    departments: 'Подразделения',
    fuel_stations: 'АЗС',
    refuel_cars: 'Бензовозы',
    equipment: 'Оборудование',
    administrative_levels: 'Регионы',
    mac: 'MAC',
    status: 'Статус',
    assigned_car: 'Машина',
    pick_car: 'Выберите бензовоз',
    equipment_status: {
      ACTIVE: 'На машине',
      SPARE: 'На складе',
      IN_SERVICE: 'На сервисе',
    },
    equipment_action: {
      assign: 'Поставить на машину',
      unassign: 'Снять',
      service: 'На сервис',
    },
    code: 'Код',
    name: 'Название',
    base_price: 'Базовая цена',
    color: 'Цвет',
    active: 'Активен',
    external_id: 'Внешний ID',
    external_id_kmazs: 'Код в КМАЗС (mpfind/mpadd)',
    fuel_type: 'Топливо',
    lat: 'Широта',
    lon: 'Долгота',
    plate_number: 'Госномер',
    capacity_liters: 'Ёмкость',
    admin_level: 'Уровень',
    parent: 'Родитель',
    region: 'Регион',
    decimal_hint: 'Дробное число, точка как разделитель (например, 1.50).',
    consumer_zones: 'Города B2C',
    city_label: 'Город',
    center: 'Центр (широта, долгота)',
    radius_km: 'Радиус, км',
    enabled: 'Включён',
    updated_at: 'Обновлён',
    zone_region_hint: 'Регион определяет тариф: цены для города берутся из раздела «Цены» по этому региону.',
    zone_radius_hint: 'Радиус зоны обслуживания в километрах, от 0 до 500.',
    zone_city_label_required: 'Укажите название города.',
    zone_city_label_too_long: 'Название города — не длиннее 64 символов.',
    zone_department_required: 'Выберите подразделение.',
    zone_region_required: 'Выберите регион.',
    zone_lat_invalid: 'Широта — число от -90 до 90.',
    zone_lon_invalid: 'Долгота — число от -180 до 180.',
    zone_radius_invalid: 'Радиус — число больше 0 и не более 500 км.',
    zone_delivery: 'Доставка',
    zone_delivery_free: 'бесплатно',
    zone_beyond: 'свыше',
    zone_delivery_max_short: 'не больше',
    zone_delivery_base: 'Доставка: фикс, ₽',
    zone_delivery_base_hint: 'Фиксированная плата за выезд, одинаковая для всего города. 0 — не брать.',
    zone_delivery_per_liter: 'Доставка: за литр, ₽',
    zone_delivery_per_liter_hint: 'Добавляется за каждый литр заказа. 0 — не брать.',
    zone_free_distance: 'Включено, км',
    zone_free_distance_hint:
      'Километры, входящие в фикс: ближе этого расстояния от центра города за километры не берём. Не больше радиуса города.',
    zone_delivery_per_km: 'Доставка: за км, ₽',
    zone_delivery_per_km_hint:
      'Берётся за каждый километр свыше включённых. 0 — расстояние на цену не влияет.',
    zone_delivery_max: 'Доставка: не больше, ₽',
    zone_delivery_max_hint:
      'Потолок для всей доставки — чтобы дальний адрес не стоил лишнего. Пусто — без потолка.',
    zone_delivery_price_invalid: 'Цена — число не меньше 0.',
    zone_delivery_per_km_too_high: 'Цена за километр — не больше 500 ₽.',
    zone_delivery_cap_below_base: 'Потолок меньше фикса — фикс тогда никогда не берётся.',
    zone_free_distance_invalid: 'Включённое расстояние — число от 0 до 500 км.',
    zone_free_distance_beyond_radius: 'Включённое расстояние больше радиуса города.',
    zone_min_liters: 'Минимальный заказ, л',
    zone_min_liters_hint:
      'Заказ меньше этого объёма всё равно принимается, но считается как за минимум — иначе выезд не окупается. Клиент видит предупреждение до оплаты.',
    zone_max_liters: 'Максимум на выезд, л',
    zone_max_liters_hint:
      'Больше этого объёма заказ не оформить. Пока это просто настройка: остаток в цистерне система ещё не ведёт.',
    zone_min_liters_invalid: 'Минимальный заказ — число больше 0.',
    zone_max_liters_invalid: 'Максимум на выезд — число больше 0.',
    zone_max_liters_too_high: 'Максимум на выезд — не больше 5000 л.',
    zone_max_liters_below_min: 'Максимум меньше минимума — так ни один заказ не пройдёт.',
    zone_urgent_fixed: 'Срочность: фикс, ₽',
    zone_urgent_fixed_hint:
      'Берётся сверх доставки, когда клиент выбрал «Срочно». Такой заказ идёт первым в очереди. 0 — срочность бесплатна.',
    zone_urgent_percent: 'Срочность: процент, %',
    zone_urgent_percent_hint:
      'Считается от топлива и доставки, складывается с фиксом. Можно оставить только одно из двух.',
    zone_dispatch_lead: 'Запас перед окном, мин',
    zone_dispatch_lead_hint:
      'За сколько минут до начала окна заказ уходит водителям, чтобы тот успел доехать к началу. По умолчанию 45.',
    zone_urgent_fixed_invalid: 'Надбавка — число не меньше 0.',
    zone_urgent_percent_invalid: 'Процент — число не меньше 0.',
    zone_urgent_percent_too_high: 'Процент срочности — не больше 100.',
    zone_dispatch_lead_invalid: 'Запас перед окном — от 0 до 240 минут.',
    zone_max_cars: 'Машин в одном выезде',
    zone_max_cars_hint:
      'Сколько машин клиент может заправить одной заявкой по одному адресу. Доставка при этом берётся один раз. По умолчанию 3.',
    zone_max_cars_invalid: 'Машин в выезде — от 1 до 10.',
  },
  operators: {
    title: 'Водители',
    show_on_map: 'Показать на карте',
    username: 'Логин',
    password: 'Пароль',
    password_hint: 'Минимум 8 символов; нельзя поменять после создания.',
    first_name: 'Имя',
    last_name: 'Фамилия',
    patronymic: 'Отчество',
    name: 'Имя',
    phone: 'Телефон',
    department: 'Подразделение',
    refuel_car: 'Бензовоз',
    can_take_self: 'Может брать сам',
    show_colors: 'Цветовая разметка',
    refuel_key: 'Ключ заправки',
    refuel_key_hint:
      '16 HEX-символов (iButton/Mifare/EM-Marine) или 19 цифр RFID (PetroPoint/ORPAK, ведущие нули — «+»).',
    refuel_key_generate: 'Сгенерировать',
    refuel_key_copy: 'Копировать',
    refuel_mode: 'Режим',
    refuel_mode_hint:
      'Интеграция — заказы каршеринга на карте. Ручной — водитель считывает номер и заправляет.',
    refuel_mode_integration: 'Интеграция',
    refuel_mode_manual: 'Ручной',
    department_required_manual: 'Для ручного режима укажите подразделение по умолчанию.',
    refuel_key_required_manual: 'Для ручного режима укажите ключ авторизации водителя.',
    show_qr: 'Показать QR',
    qr_intro:
      'Выдать новый пароль и QR-код входа для «{{username}}»? Старый пароль перестанет работать.',
    qr_confirm: 'Выдать QR',
    qr_issued: 'QR-код выдан',
    qr_show_once_warning:
      'Пароль показывается один раз и больше нигде не хранится. Отсканируйте QR в приложении водителя или скопируйте пароль вручную.',
    qr_share: 'Поделиться',
    qr_copy_image: 'Копировать QR',
    online: 'Онлайн',
    active_orders: 'Заказы',
    providers: 'Провайдеры',
    providers_hint: 'Без выбора водитель видит все каршеринги. Выберите — ограничить.',
    lock: 'Заблокировать',
    unlock: 'Разблокировать',
    locked_badge: 'Заблокирован',
    lock_confirm_intro:
      'Заблокировать доступ для «{{username}}»? Сессии на всех устройствах завершатся немедленно. Действие обратимо — снять блокировку можно в любой момент.',
    lock_confirm_button: 'Заблокировать',
    unlock_confirm_intro: 'Снять блокировку с «{{username}}»?',
    unlock_confirm_button: 'Разблокировать',
    wipe_device: 'Удалённо стереть устройство',
    wipe_confirm_intro:
      'Полный сброс телефона «{{username}}» до заводских настроек (factory reset). Действие НЕОБРАТИМО и применяется только к устройствам в режиме Device Owner.',
    wipe_confirm_type_hint: 'Чтобы подтвердить, введите логин «{{username}}» ниже.',
    wipe_confirm_button: 'Стереть устройство',
    wipe_requested: 'Команда на стирание отправлена. Устройство не может подтвердить выполнение.',
  },
  providers: {
    title: 'Провайдеры',
    code: 'Код',
    name: 'Название',
    integration_url: 'URL интеграции',
    default_department: 'Подразделение по умолчанию',
    active: 'Активен',
    auto_record_video: 'Автозапись видео',
    rotate_token: 'Выпустить токен',
    rotate_intro:
      'Выпуск нового токена для {{provider}}. Прежние токены продолжают работать до явного отзыва.',
    token_name: 'Метка токена',
    token_name_placeholder: 'production / staging / smoke',
    rotate_confirm: 'Выпустить',
    token_issued: 'Новый токен',
    show_once_warning:
      'Этот токен показывается один раз. Скопируйте и сохраните его сейчас — после закрытия окна восстановить нельзя.',
    internal_locked_hint: 'Системный провайдер ручной заправки — токены и удаление недоступны.',
  },
  admins: {
    title: 'Пользователи',
    username: 'Логин',
    name: 'Имя',
    first_name: 'Имя',
    last_name: 'Фамилия',
    role: 'Роль',
    no_role: '— без роли —',
    active: 'Активен',
    password: 'Пароль',
    password_hint: 'Минимум 8 символов.',
    password_reset: 'Новый пароль',
    password_reset_hint: 'Оставьте пустым, чтобы не менять.',
  },
  admin_roles: {
    title: 'Роли и права',
    name: 'Название',
    description: 'Описание',
    permissions: 'Права',
    full_access: 'Полный доступ',
    full_access_warning: '«Полный доступ» обходит любую другую проверку прав в этой роли.',
  },
  pricing: {
    set_override: 'Новый прайс',
    edit_override: 'Изменить прайс',
    region: 'Регион',
    provider: 'Провайдер',
    fuel: 'Топливо',
    unit_price: 'Цена за литр',
    services: 'Услуги',
    fuel_section: 'Топливо',
    delivery: 'Доставка',
    surcharges: 'Доплаты (по запросу)',
    surcharges_toggle_show: 'Показать доплаты',
    surcharges_toggle_hide: 'Скрыть доплаты',
    rate: 'Ставка',
    billing_unit: 'Единица',
    billing_per_litre: 'За литр',
    billing_per_order: 'За выезд',
    billing_fixed: 'Фикс',
    unit_short_per_litre: '₽/л',
    unit_short_per_order: '₽/выезд',
    unit_short_fixed: '₽',
    threshold: 'Порог, л',
    threshold_suffix: 'при < {{n}} л',
    history: 'История',
    empty: 'Прайсов пока нет.',
    active: 'Активно',
    closed: 'Закрыто',
    triple_required: 'Выберите регион, провайдера и топливо.',
    none: '—',
    preview_liters: 'Литров для расчёта',
    preview_total: 'Расчёт за {{n}} л',
    preview_plus_surcharges: '+ доплаты по запросу',
    surcharges_count: '{{n}} доплат',
    kind_fuel: 'Топливо',
    kind_service: 'Услуга',
  },
  personal_car_settings: {
    title: 'Отмена и неявка клиента',
    subtitle:
      'Настройки применяются только к заказам «Личный автомобиль» (B2C). Штраф за отмену/неявку — это цена услуги «Доставка» из прайса, настраивается на странице «Цены».',
    wait_label: 'Время ожидания доступа к машине, мин.',
    wait_helper:
      'Если водитель приехал, а клиент не обеспечил доступ к машине за это время — заказ автоматически отменяется как неявка, штраф (стоимость доставки) списывается с холда, остаток возвращается.',
    save: 'Сохранить',
    saved: 'Настройки сохранены',
    save_failed: 'Не удалось сохранить',
    load_failed: 'Не удалось загрузить настройки',
    range_hint: 'От 1 до 120 минут',
  },
  consumers: {
    col_email: 'Почта',
    col_status: 'Статус',
    col_registered_at: 'Регистрация',
    col_orders: 'Заказы (активные / всего)',
    col_unpaid_overflow: 'Долг',
    col_deletion_request: 'Удаление',
    deletion_pending: 'Запрошено',
    refuels: 'Заправки',
    change_status: 'Статус',
    change_status_title: 'Изменить статус клиента',
    filter_status: 'Статус:',
    filter_all: 'Все',
    search_placeholder: 'Поиск по почте',
    total: 'Всего: {{n}}',
    empty: 'Клиентов нет.',
    prev: 'Назад',
    next: 'Вперёд',
    status_ACTIVE: 'Активен',
    status_SUSPENDED: 'Заблокирован',
    status_UNDER_REVIEW: 'На проверке',
    status_hint_ACTIVE: 'Клиент может создавать заказы.',
    status_hint_SUSPENDED: 'Клиент не сможет создать новый заказ — приложение покажет отказ.',
    status_hint_UNDER_REVIEW:
      'Пометка для поддержки: на заказы не влияет, клиент ничего не заметит.',
    active_orders_warning:
      'У клиента сейчас активных заказов: {{n}}. Смена статуса их не отменит и не вернёт деньги — заправка состоится.',
  },
  chat: {
    new_message_title: 'Новое сообщение в чате',
    new_approval_title: 'Требуется одобрение заправки',
    tab_operators: 'Водители',
    tab_consumers: 'Клиенты',
    operators_label: 'Список водителей',
    back_to_operators: 'К списку водителей',
    no_operators: 'Водителей нет.',
    pick_operator: 'Выберите водителя слева.',
    consumers_label: 'Список клиентов',
    back_to_consumers: 'К списку клиентов',
    no_consumers: 'Обращений от клиентов нет.',
    pick_consumer: 'Выберите обращение слева.',
    consumer_fallback_label: 'Клиент {{id}}',
    message_placeholder_consumer: 'Сообщение клиенту…',
    typing_consumer: 'клиент печатает…',
    empty: 'Сообщений ещё нет.',
    message_input: 'Сообщение',
    message_placeholder: 'Сообщение водителю…',
    send: 'Отправить',
    read: 'прочитано',
    read_mark: '✓✓',
    unread: '{{count}} непрочитанных',
    typing: 'водитель печатает…',
    attach_file: 'Прикрепить фото',
    record: 'Записать голосовое',
    stop_record: 'Стоп',
    cancel_record: 'Отменить запись',
    recording: 'Идёт запись…',
    remove_attachment: 'Убрать вложение',
    attachment_loading: 'Загрузка вложения…',
    attachment_failed: 'Не удалось загрузить вложение',
    image_alt: 'Вложение-изображение',
    download_file: 'Скачать файл',
    mic_error: 'Нет доступа к микрофону',
    approval_title: 'Запрос подтверждения',
    open_order: 'Открыть заказ',
    approve: 'Одобрить',
    reject: 'Отклонить',
    approved: 'Одобрено',
    rejected: 'Отклонено',
  },
  refill: {
    operator: 'Водитель',
    requested_at: 'Запрошена',
    status: 'Статус',
    decline_reason: 'Причина отказа',
    fuel_station: 'АЗС',
    station_optional: 'необязательно',
    approve: 'Одобрить',
    decline: 'Отклонить',
    approve_title: 'Одобрить заявку',
    decline_title: 'Отклонить заявку',
    empty: 'Заявок нет.',
    status_PENDING: 'Ожидают',
    status_APPROVED: 'Одобренные',
    status_DECLINED: 'Отклонённые',
    status_COMPLETED: 'Выполненные',
    status_CANCELLED: 'Отменённые',
  },
  reports: {
    from: 'С даты',
    to: 'По дату',
    download: 'Скачать XLSX',
    completed_orders: 'Завершённые заказы',
    operators_summary: 'Сводка по водителям',
    providers_summary: 'Сводка по провайдерам',
    last_size: 'Размер файла: {{bytes}} байт.',
    open_builder: 'Конструктор отчётов',
  },
  report_builder: {
    title: 'Конструктор отчётов',
    subtitle: 'Любое поле — в любой отчёт: колонки, фильтры, группировки и живой предпросмотр',
    recipients_label: 'Доступно клиентам',
    recipients_hint: 'Отмеченные клиенты увидят этот отчёт в своём кабинете',
    catalog_title: 'Каталог полей',
    catalog_search: 'Найти поле…',
    catalog_unavailable: 'Каталог полей недоступен — бэкенд не отвечает. Попробуйте позже.',
    catalog_retry: 'Повторить',
    catalog_empty_search: 'Ничего не нашлось по «{{query}}».',
    section_columns: 'Колонки',
    section_filters: 'Фильтры',
    section_group: 'Группировка',
    section_aggregates: 'Агрегаты',
    section_sort: 'Сортировка',
    columns_empty: 'Кликните поле в каталоге слева — оно станет колонкой отчёта.',
    columns_drag_hint: 'Порядок чипов = порядок колонок в файле. Перетаскивайте, чтобы поменять.',
    filters_empty:
      'Без фильтров отчёт соберётся по всем данным. Добавьте условие, чтобы сузить выборку.',
    add_condition: 'Условие',
    add_group: 'Группа ИЛИ',
    logic_and: 'И',
    logic_or: 'ИЛИ',
    logic_and_hint: 'выполняются все условия',
    logic_or_hint: 'достаточно любого условия',
    group_remove: 'Удалить группу',
    condition_field_placeholder: 'Поле',
    condition_op_label: 'Сравнение',
    condition_value_placeholder: 'Значение',
    condition_values_placeholder: 'Значение + Enter',
    condition_remove: 'Удалить условие',
    between_from: 'от',
    between_to: 'до',
    group_by_empty: 'Сгруппируйте строки — например, по виду топлива или по неделям.',
    add_group_by: 'Группировка',
    aggregates_hint: 'Итоги по каждой группе: сумма, среднее, количество…',
    aggregates_empty: 'Добавьте итог по метрике — без него группы покажут только ключи.',
    add_aggregate: 'Агрегат',
    aggregate_metric_placeholder: 'Метрика',
    aggregate_fn_placeholder: 'Функция',
    sort_empty: 'Без сортировки строки идут в порядке базы.',
    add_sort: 'Сортировка',
    sort_dir_label: 'Направление',
    dir_asc: 'по возрастанию',
    dir_desc: 'по убыванию',
    preview_title: 'Предпросмотр',
    preview_rows: '{{total}} строк · показаны первые {{shown}}',
    preview_rows_exact: 'Строк: {{total}}',
    preview_truncated: 'Показаны первые {{shown}} строк из {{total}} — сузьте фильтр, если нужны все.',
    preview_start_title: 'Начните с колонок',
    preview_fix_title: 'Почти готово',
    preview_empty: 'Запрос выполнен, но строк нет. Ослабьте фильтры или расширьте период.',
    preview_error_cost_title: 'Запрос слишком тяжёлый',
    preview_error_busy: 'Отчёт уже считается — подождите немного и попробуйте снова.',
    preview_error_bad_input: 'Сервер отклонил запрос: {{message}}',
    preview_error_forbidden: 'Недостаточно прав для этого набора полей.',
    preview_error_unavailable: 'Бэкенд недоступен. Предпросмотр обновится, когда появится связь.',
    name_placeholder: 'Название отчёта',
    saved_select_placeholder: 'Сохранённые отчёты',
    new_report: 'Новый отчёт',
    delete_report: 'Удалить отчёт',
    delete_confirm: 'Удалить отчёт «{{name}}»? Действие необратимо.',
    download_xlsx: 'Скачать XLSX',
    download_pdf: 'Скачать PDF',
    saved_toast: 'Отчёт сохранён',
    deleted_toast: 'Отчёт удалён',
    name_required: 'Дайте отчёту название, чтобы сохранить.',
    definition_broken: 'Сохранённый отчёт не читается — возможно, создан другой версией.',
    issue_no_columns: 'Добавьте хотя бы одну колонку из каталога слева.',
    issue_condition_no_field: 'В фильтре есть условие без поля — выберите поле или удалите строку.',
    issue_condition_no_value: 'Заполните значение условия в фильтре.',
    issue_condition_bad_number: 'Значение условия должно быть числом.',
    issue_between_incomplete: 'Для «между» нужны обе границы.',
    issue_between_inverted: 'Левая граница «между» больше правой.',
    issue_group_by_incomplete: 'Выберите поле группировки или удалите пустую строку.',
    issue_aggregate_incomplete: 'Выберите метрику и функцию агрегата.',
    issue_sort_incomplete: 'Выберите поле сортировки или удалите пустую строку.',
    client_subtitle: 'Соберите отчёт по своим заправкам: колонки, фильтры и живой предпросмотр',
    client_stub_title: 'Конструктор не подключён',
    client_stub_body: 'Обратитесь к менеджеру, чтобы вам подключили конструктор отчётов.',
    client_unavailable_title: 'Конструктор временно недоступен',
    client_unavailable: 'Сервис не отвечает. Попробуйте позже.',
  },
  report_fields: {
    category_order: 'Заказ',
    category_geo: 'Гео и расстояния',
    category_fuel: 'Топливо и цены',
    category_services: 'Услуги',
    category_operator: 'Водитель',
    category_provider: 'Провайдер',
    category_fleet: 'Парк и техника',
    category_media: 'Медиа',
    category_chat: 'Чат',
    category_cancellation: 'Отмены',
    category_audit: 'Аудит',
    kind_dimension: 'дименшн',
    kind_measure: 'метрика',
    kind_timestamp: 'дата',
    sensitivity_pricing: 'цены',
    sensitivity_media: 'медиа',
    sensitivity_internal: 'служебное',
    op_eq: 'равно',
    op_ne: 'не равно',
    op_lt: 'меньше',
    op_le: 'не больше',
    op_gt: 'больше',
    op_ge: 'не меньше',
    op_in: 'любое из',
    op_not_in: 'ни одно из',
    op_between: 'между',
    op_is_null: 'пусто',
    op_not_null: 'не пусто',
    op_contains: 'содержит',
    agg_sum: 'сумма',
    agg_avg: 'среднее',
    agg_min: 'минимум',
    agg_max: 'максимум',
    agg_count: 'количество',
    agg_count_distinct: 'уникальные',
    granularity_day: 'День',
    granularity_week: 'Неделя',
    granularity_month: 'Месяц',
  },
  clients: {
    subtitle: 'Кабинеты каршерингов — доступ к своим завершённым заправкам',
    create: 'Создать кабинет',
    reports_title: 'Отчёты клиента',
    reports_subtitle: 'Отметьте отчёты, которые клиент увидит в своём кабинете',
    reports_unavailable: 'Не удалось загрузить список отчётов',
    reports_none_available: 'У вас пока нет сохранённых отчётов. Соберите отчёт в конструкторе.',
    username: 'Логин',
    password: 'Пароль',
    password_auto_hint: 'Сгенерирован автоматически. Скопируйте и передайте клиенту.',
    regenerate: 'Сгенерировать заново',
    company: 'Компания',
    company_placeholder: 'BelkaCar',
    company_select: 'Выберите компанию',
    providers: 'Провайдеры',
    providers_required:
      'Выберите хотя бы одного провайдера — иначе кабинет не увидит ни одной заправки.',
    internal_provider_warning: 'системный провайдер ручной заправки — рекомендуем убрать',
    regions: 'Регионы',
    regions_hint: 'Пусто — все регионы.',
    fuel_types: 'Топливо',
    fuel_hint: 'Пусто — все виды топлива.',
    can_view_media: 'Видит видео заправок',
    can_export: 'Может строить отчёты (XLSX/PDF)',
    can_view_pricing: 'Видит цены',
    completed_only: 'Только завершённые заказы',
    date_from: 'Видит заказы с даты',
    date_to: 'Видит заказы по дату',
    dates_hint: 'Пусто — без ограничения по датам (видит все свои заправки).',
    created_title: 'Кабинет создан',
    created_hint:
      'Передайте клиенту логин и пароль. Вход — по тому же адресу, что и админка. Пароль показывается один раз.',
    copy_credentials: 'Копировать логин и пароль',
    review_hint: 'Проверьте настройки и создайте кабинет.',
    step: 'Шаг {{n}} из {{total}}',
    next: 'Далее',
    back: 'Назад',
    finish: 'Создать кабинет',
    step_access: 'Доступ',
    step_providers: 'Провайдеры',
    step_regions: 'Регионы',
    step_scope: 'Топливо',
    step_permissions: 'Права',
    step_review: 'Проверка',
    err_username: 'Логин — минимум 3 символа.',
    err_password: 'Пароль — минимум 8 символов.',
    err_providers: 'Выберите хотя бы одного провайдера.',
    all: 'все',
    none: 'нет',
    yes: 'да',
    no: 'нет',
    col_provider_scope: 'Провайдеры',
    col_permissions: 'Права',
    col_active: 'Активен',
    perm_media: 'видео',
    perm_export: 'отчёты',
    perm_pricing: 'цены',
    edit_title: 'Кабинет клиента',
    scope_section: 'Область видимости',
    flags_section: 'Права и окно дат',
    report_builder_section: 'Конструктор отчётов',
    can_build_reports: 'Может собирать свои отчёты в конструкторе',
    report_fields_hint:
      'Отметьте поля, доступные кабинету в конструкторе. Пустой набор — клиент не увидит ни одного поля.',
    report_fields_unavailable:
      'Каталог полей недоступен — бэкенд не отвечает. Набор полей при сохранении не изменится.',
    report_fields_pricing_locked: 'Недоступно: у кабинета нет права «Видит цены».',
    report_fields_select_all: 'Выбрать все',
    report_fields_clear_all: 'Снять все',
    report_fields_selected_n: 'Выбрано полей: {{n}}',
    reset_password: 'Сбросить пароль',
    reset_password_intro:
      'Выдать новый пароль для «{{username}}»? Старый пароль перестанет работать.',
    reset_password_confirm: 'Выдать новый пароль',
    password_issued: 'Пароль выдан',
    password_show_once_warning:
      'Пароль показывается один раз и больше нигде не хранится. Скопируйте и передайте клиенту.',
  },
  client_reports: {
    title: 'Отчёты',
    subtitle: 'Отчёты, подготовленные для вас',
    empty_title: 'Пока нет отчётов',
    empty_body: 'Здесь появятся отчёты, которые для вас соберёт менеджер.',
    unavailable: 'Не удалось загрузить отчёты. Повторите попытку.',
    download_failed: 'Не удалось скачать отчёт',
  },
  client_cabinet: {
    brand: 'Кабинет клиента',
    title: 'Заправки',
    nav_builder: 'Конструктор отчётов',
    subtitle: 'Ваши завершённые заправки',
    filter_from: 'С даты',
    filter_to: 'По дату',
    filter_car: 'Гос. номер',
    apply: 'Применить',
    reset: 'Сбросить',
    export_xlsx: 'Экспорт XLSX',
    export_pdf: 'Экспорт PDF',
    col_datetime: 'Дата и время',
    col_truck: 'Бензовоз',
    col_driver: 'Водитель',
    col_car: 'Авто',
    col_make: 'Марка техники',
    col_city: 'Город',
    col_fuel: 'ГСМ',
    col_liters: 'Кол-во',
    col_price: 'Цена',
    col_fuel_sum: 'Сумма',
    col_delivery: 'Доставка',
    col_services: 'Сумма услуг',
    col_total: 'Сумма итого',
    col_external: 'Внешний ID',
    col_state: 'Статус',
    col_unit_price: 'Цена/л',
    col_completed: 'Завершён',
    col_video: 'Видео',
    col_photo: 'Фото',
    watch: 'Смотреть',
    videos_title: 'Видео заправки',
    photos_title: 'Фото заправки',
    no_videos: 'Видео нет.',
    no_photos: 'Фото нет.',
    download: 'Скачать',
    loading_video: 'Загрузка видео…',
    loading_photo: 'Загрузка фото…',
    video_failed: 'Не удалось загрузить видео.',
    photo_failed: 'Не удалось загрузить фото.',
    total_count: 'Всего: {{n}}',
    prev: 'Назад',
    next: 'Вперёд',
    empty: 'Заправок нет.',
    state_completed: 'Завершён',
  },
} as const;

export type Resources = typeof ru;
